module.exports = __webpack_public_path__ + "assets/img/cd93bfdd88383ffc8b08250df95ea81b.svg";